(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarToolbar', rmsFilterBarToolbar);

    function rmsFilterBarToolbar() {
        return {
            restrict: 'E',
            scope: {
                options: '='
            },
            controller: rmsFilterBarToolbarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/toolbar'
        };
    }

    function rmsFilterBarToolbarCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier; // still required in this directive as the child directive will reference this.
        }

    }
})();